import { useState } from "react";

/**
 * AnimatedBookLogo — the navbar brand asset.
 *
 * Renders the Torahya book cover (logo-navbar.png). On hover/focus,
 * a warm gold light burst radiates outward from behind the book and the
 * book itself lifts slightly with a faint glow on the cover. CSS-only.
 */
export default function AnimatedBookLogo({ size = 44 }) {
  const [hover, setHover] = useState(false);
  return (
    <span
      className="anim-book-logo"
      style={{ width: size, height: size }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onFocus={() => setHover(true)}
      onBlur={() => setHover(false)}
      data-hover={hover ? "1" : "0"}
      data-testid="navbar-animated-logo"
      aria-hidden="true"
    >
      {/* Outer radiant burst — sits BEHIND the book, fades in on hover */}
      <span className="anim-book-glow anim-book-glow-outer" />
      {/* Inner sharp glow — adds intensity at the core */}
      <span className="anim-book-glow anim-book-glow-inner" />
      {/* The book itself */}
      <img
        src="/brand/logo-navbar.png"
        alt=""
        draggable={false}
        className="anim-book-img"
      />
    </span>
  );
}
